module.exports = __webpack_public_path__ + "media/images/tavour_logo_with_name-940bb42463ed57c434ebdc5adf946580.png";